var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['n-toggle-container', _vm.className]},[(_vm.showIcon)?_c('div',{class:['n-toggle-icon', `social-icon-${_vm.size}`],attrs:{"data-testid":`${_vm.id}-icon`}},[_vm._t("icon")],2):_vm._e(),_c('label',{class:{ 'n-switch': true, [_vm.size]: true },attrs:{"for":_vm.id}},[_c('input',{class:['n-toggle-input', _vm.className],style:(_vm.inputStyle),attrs:{"id":_vm.id,"data-testid":`${_vm.id}-input`,"type":"checkbox","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.toggleValue,"value":_vm.toggleValue},on:{"change":_vm.onChange}}),_c('span',{class:{
        'n-slider n-round': true,
        'n-disabled': _vm.disabled,
        'success-state': _vm.state == 'success',
        'warning-state': _vm.state == 'warning',
        'error-state': _vm.state == 'error',
        checked: _vm.toggleValue,
      }},[_c('div',{class:{
          'slider-ball': true,
          checked: _vm.toggleValue,
        }})]),_c('span',{class:{
        'label-text': true,
        'n-disabled': _vm.disabled,
        checked: _vm.toggleValue,
      }},[_vm._t("default")],2),(_vm.state !== 'default')?_c('n-validation',{class:'n-toggle-validation',attrs:{"data-testid":_vm.id,"validationState":_vm.state,"label":_vm.stateMessage,"isHidden":_vm.state === null}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }